import React from "react";
export const PageType = React.createContext();
